module.exports = __webpack_public_path__ + "img/ico-contact.ba1e0204.svg";